import styled from "styled-components";
import Button from "../Button";

export const EditSectionContainer = styled.div`
    postition: relative;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const EditButton = styled(Button)`
    position: absolute;
    right: 6%;
`

export const PlusButtonContainer = styled.div`
    position: absolute;
    right: 0;
`